import React, { lazy } from 'react';
export function VideoShowcase() {
  return <section className="bg-white py-20 lg:py-28 font-heading" data-id="element-185">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B3A5C] mb-4 uppercase tracking-tight" data-id="element-188">
            See Our Drones in Action
          </h2>
          <p className="text-lg text-[#1E1E1E]/80" data-id="element-189">
            Watch how our fleet tackles real jobs — from hotel exteriors to
            residential rooftops.
          </p>
        </div>

        <div className="flex flex-col gap-12 max-w-5xl mx-auto" data-id="element-190">
          {/* Primary Video */}
          <div className="flex flex-col items-center w-full" data-id="element-191">
            <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-2xl bg-black" data-id="element-192">
              <video className="w-full h-full object-cover" autoPlay muted loop playsInline loading="lazy" poster="https://lirp.cdn-website.com/d7afec65/dms3rep/multi/opt/KiXUc2x3QDy7aH5Moheg_dji_fly_20251118_201316_0619_1764388666445_video.v2.0000000-1920w.jpg" data-id="element-193">
                <source src="https://vid.cdn-website.com/d7afec65/videos/KiXUc2x3QDy7aH5Moheg_dji_fly_20251118_201316_0619_1764388666445_video-v.mp4" type="video/mp4" data-id="element-194" />
                Your browser does not support the video tag.
              </video>
            </div>
            <p className="mt-4 text-sm text-muted-foreground text-center" data-id="element-195">
              Busy Drones Cleaners completing a commercial exterior wash in
              Yuma, AZ.
            </p>
          </div>

          {/* Secondary YouTube Embed */}
          <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-xl bg-black" data-id="element-196">
            <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/dgztF5_fIpU?rel=0" title="Busy Drones Cleaners YouTube Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen loading="lazy" data-id="element-197"></iframe>
          </div>
        </div>
      </div>
    </section>;
}